module.exports = __webpack_public_path__ + "img/44_7.a29ff53c.png";